import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import { HttpResponse, Interview, InterviewQueryParams } from "@/types";

export function useDeleteRemoveInterview({
  companyId,
  jobId,
  queryParams,
}: {
  companyId: string;
  jobId: string;
  queryParams: InterviewQueryParams;
}) {
  const queryClient = useQueryClient();
  const queryString = misc.prepareQueryParams(queryParams).toString();

  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const path = `companies/${companyId}/jobs/${jobId}/interviews/${id.toString()}`;
      const res = await guacHttpClient.delete<
        Interview,
        HttpResponse<Interview>
      >(path);

      return res.data;
    },
    onSuccess: (_, variables) => {
      queryClient.setQueryData(
        ["interviews", companyId, jobId, queryString],
        (cachedData?: Interview[]) => {
          if (!cachedData) return cachedData;
          return cachedData.filter(
            (interview) => interview.id !== variables.id,
          );
        },
      );
    },
  });
}
